import React from 'react';

const stats = [
  { number: '150+', label: 'Projects' },
  { number: '50+', label: 'Clients' },
  { number: '6+', label: 'Years' },
  { number: '25+', label: 'Engineers' },
];

function About() {
  return (
    <section id="about" className="section">
      <div className="section-inner">
        <div className="about-grid">
          {/* Image */}
          <div className="rv">
            <div className="about-img-wrap">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
                alt="Square Production team working collaboratively in modern office"
              />
              <div className="about-img-decor-1"></div>
              <div className="about-img-decor-2"></div>
            </div>
          </div>

          {/* Content */}
          <div className="rv rv-d2">
            <span className="label-tag" style={{ marginBottom: '1.5rem', display: 'block' }}>About Us</span>
            <h2 className="section-title" style={{ marginBottom: '2rem' }}>
              A studio obsessed with craft and impact
            </h2>

            <div className="about-text">
              <p>
                Square Production was founded in 2018 with a clear conviction: technology should serve human needs, not the other way around. We're a tight-knit team of engineers, designers, and strategists who believe that the best digital products emerge from deep understanding and meticulous execution.
              </p>
              <p>
                From ambitious startups to Fortune 500 enterprises, we've partnered with forward-thinking organizations across fintech, healthcare, e-commerce, and education to deliver software that users genuinely love and businesses depend on.
              </p>
            </div>

            <div className="about-stats">
              {stats.map((stat, i) => (
                <div key={i}>
                  <p className="stat-number">{stat.number}</p>
                  <p className="stat-label">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
